/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMiscBillDetail.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/misc-bill-detail";

export class AutogenModelMiscBillDetail<RowType extends ModelRow> extends Endpoint<RowType, RowMiscBillDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMiscBillDetail extends ModelRow<RowMiscBillDetailFields> {
	constructor(values?: Partial<RowMiscBillDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMiscBillDetailFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	charge_id: string;
	charge_method: string;
	charge_units: number;
	company_id: string;
	descr: string;
	id: string;
	is_taxable: string;
	misc_bill_id: string;
	rate: number;
	sequence: number;
}

